import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbfba756"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "info"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "任务类型", -1))
const _hoisted_3 = { class: "xn-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "开始时间", -1))
const _hoisted_5 = { class: "xn-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "结束时间", -1))
const _hoisted_7 = { class: "xn-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "任务状态", -1))
const _hoisted_9 = { class: "xn-text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "数据大小", -1))
const _hoisted_12 = { class: "xn-text" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "失败原因", -1))
const _hoisted_15 = { class: "xn-text" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "原FTP地址", -1))
const _hoisted_17 = { class: "xn-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "目标路径", -1))
const _hoisted_19 = { class: "xn-text" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "文件个数", -1))
const _hoisted_21 = { class: "xn-text" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "失败文件个数", -1))
const _hoisted_23 = { class: "xn-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "程序名", -1))
const _hoisted_25 = { class: "xn-text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "安装路径", -1))
const _hoisted_27 = { class: "xn-text" }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "备份文件名", -1))
const _hoisted_30 = { class: "xn-text" }
const _hoisted_31 = { key: 5 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "备份文件名", -1))
const _hoisted_33 = { class: "xn-text" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "源备份文件名", -1))
const _hoisted_35 = { class: "xn-text" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xn-tip" }, "源备份文件大小", -1))
const _hoisted_37 = { class: "xn-text" }

import { ref, watch } from 'vue'
import { getCloneInfo } from '@/api/task'

interface Props {
  row: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props
const param: any = ref()
const info: any = ref<string>()

const getTaskStatus = (value) => {
  return Xinnet.settings.taskStatusOpts.find((o) => (
    o.value === value
  ))?.text
}

const getTaskType = (value, key) => {
  return Xinnet.settings.taskTypeOpts.find((o) => {
    return o.value === value
  })?.[key]
}

const getDataSize = (data) => {
  return Xinnet.util.fileDiskSize(data, 2)
}

// 获取网站搬家数据
const getSite = async (taskCode) => {
  try {
    const res: any = await getCloneInfo(taskCode)
    const o = res.res
    param.value.fileNum = o.copiedFiles || 0
    param.value.failFileNum = o.failed?.length || 0
    if (o.copiedBytes) {
      param.value.dataSize = getDataSize(o.copiedBytes)
    } else {
      param.value.dataSize = ''
    }
  } catch(e) {
    console.log('网站搬家解析错误！')
  }
}

const load = (row) => {
  if (row) {
    try {
      if (row.taskParam) {
        param.value = JSON.parse(row.taskParam)
      }
      if (row.taskInfo) {
        info.value = row.taskInfo
      }
    } catch(e) {
      console.log('详情数据解析错误！')
    }
  
    if (row.taskType === 'SITE_MOVE' && row.preTaskCode) {
      getSite(row.preTaskCode)
    }
  }
}

watch(() => props.row, load, { deep: true, immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_a_badge = _resolveComponent("a-badge")!

  return (_ctx.row)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(getTaskType(_ctx.row.taskType, 'text')), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.row.createTime), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.row.endTime), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_a_badge, {
              color: _ctx.$util.getBadgeColor(_ctx.row.taskStatus),
              text: getTaskStatus(_ctx.row.taskStatus)
            }, null, 8, ["color", "text"])
          ])
        ]),
        (param.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(param.value.dataSize), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.row.taskStatus === 'RUNNING_FAIL')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.row.taskInfo), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.row.taskType === 'SITE_MOVE' && param.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", null, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, _toDisplayString(param.value.ftpServer), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(param.value.targetPath), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(param.value.fileNum) + "个", 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(param.value.failFileNum) + "个", 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.row.taskType === 'APP_INSTALL' && param.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", null, [
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, _toDisplayString(param.value.appName), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, _toDisplayString(param.value.targetPath), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.row.taskType === 'WEB_BACKUP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(info.value
              ? info.value === 'empty'
                ? ''
                : info.value.slice(info.value.lastIndexOf('/') + 1)
              : ''), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.row.taskType === 'DB_BACKUP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("span", _hoisted_33, _toDisplayString(info.value
              ? info.value === 'empty'
                ? ''
                : info.value.slice(info.value.lastIndexOf('/') + 1)
              : ''), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.row.taskType === 'WEB_BACKUP_RESTORE' && param.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createElementVNode("div", null, [
                _hoisted_34,
                _createElementVNode("span", _hoisted_35, _toDisplayString(param.value.objectName ? param.value.objectName.slice(param.value.objectName.lastIndexOf('/') + 1) : ''), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_36,
                _createElementVNode("span", _hoisted_37, _toDisplayString(param.value.size ? getDataSize(param.value.size) : ''), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})